import React from 'react'

const ValueCheckIcon = props => (
  <svg
    className="ipacket-value-check-icon"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 400 400"
  >
    <path
      className="g ipacket-value-check-icon-path"
      d="M312.9,60.2c-1.2.9-14.3-9.4-16.9-10.9C166.4-31.5,5,73.6,24.7,224.4c15.8,122.3,153.4,190.6,261.7,130.9,96.3-53.1,121.8-181.3,53-267.4-.1-1,7.5-15.5,8.6-17.1,3.2-4.4,8.6,4.9,11.3,8.2,66.9,84.3,50,210.3-32.7,277.3C215.2,446.3,46.3,392.6,8.2,255.1-37.3,91.3,127.5-50.6,283.1,18.5c6.1,2.7,35.9,18.7,38.1,23.2,2.2,4.5-8.2,14.1-8.3,18.6Z"
    />
    <path
      className="g ipacket-value-check-icon-path"
      d="M93.2,131.1l87.3,173.5,39-1.2,103.9-186.7,2.3.7c55.1,84.9,12.7,201.3-85.5,227.9-118.8,32.2-223.1-82.6-180.3-198C95.9,50.1,219.4,19,298,86.2l-98.5,176-64.5-131.1h-41.8Z"
    />
  </svg>
)
export default ValueCheckIcon
